import * as models from '../../domain/models';
import * as actions from '../actions/application-config-detail';

import * as _ from 'lodash';

export interface State {
  isLoaded: boolean;
  isLoading: boolean;
  initialItem: models.ApplicationConfig;
  editedItem: models.ApplicationConfig;
  pristine: boolean;
  editMode: boolean;
}

const initialState: State = {
  isLoaded: false,
  isLoading: false,
  initialItem: new models.ApplicationConfig(),
  editedItem: new models.ApplicationConfig(),
  pristine: true,
  editMode: false,
};

export function reducer(state = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.LOAD: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    }

    case actions.RESET: {
      return { ...initialState };
    }

    case actions.LOAD_SUCCESS: {
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        pristine: true,
        initialItem: _.cloneDeep(action.payload.item),
        editedItem: _.cloneDeep(action.payload.item),
      };
    }

    case actions.SET: {
      let pristine = _.cloneDeep(state.pristine);
      const compare1 = _.cloneDeep(state.editedItem);
      const compare2 = _.cloneDeep(action.payload.item);
      if (!_.isEqual(compare1, compare2)) {
        pristine = false;
      }

      return {
        ...state,
        pristine,
        editedItem: _.cloneDeep(action.payload.item),
      };
    }

    case actions.CANCEL: {
      return {
        ...state,
        pristine: false,
        editedItem: _.cloneDeep(state.initialItem),
      }
    }

    case actions.LOAD_FAIL: {
      return {
        ...initialState,
        isLoaded: true,
      };
    }

    case actions.SAVE: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case actions.SAVE_SUCCESS: {
      return {
        ...state,
        pristine: true,
        isLoading: false,
        initialItem: _.cloneDeep(action.payload.item),
        editedItem: _.cloneDeep(action.payload.item),
      };
    }

    case actions.SAVE_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case actions.TOGGLE_EDIT_MODE: {
      return {
        ...state,
        editMode: !state.editMode,
      }
    }

    default: {
      return state;
    }
  }
}

export const getIsLoaded = (state: State) => state.isLoaded;
export const getIsLoading = (state: State) => state.isLoading;
export const getItem = (state: State) => state.editedItem;
export const getPristine = (state: State) => state.pristine;
export const getIsEditMode = (state: State) => state.editMode;
